import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { getIsAdoptableOfferType } from '../utils/adoptables';
import OfferBanner from './OfferBanner';
import OfferBannerMobile from './OfferBannerMobile';
export const MonetizationStrip = ({ className, deviation, onAdoptableSaleEnd })=>{
    var _deviation_extended, _deviation_extended_adoptable, _deviation_extended1, _deviation_extended2, // Adoptables that aren't on sale should show the monetization banners as usual.
    _deviation_adoptable, _deviation_adoptable1, _deviation_adoptable2;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const isAdoptable = !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable);
    const offers = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.offers;
    const promo = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended2 = deviation.extended) === null || _deviation_extended2 === void 0 ? void 0 : _deviation_extended2.showStageMonetizationPromo;
    if (isAdoptable && ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.status) !== 'not_onsale') {
        if (isDesktop || !deviation.adoptable || !getIsAdoptableOfferType(deviation)) {
            return null;
        }
        if (isMobile) {
            return null;
        }
        if (deviation.adoptable.status === 'sold') {
            return null;
        }
        return /*#__PURE__*/ React.createElement(OfferBannerMobile, _object_spread_props(_object_spread({
            className: className
        }, offers), {
            ownOffer: offers === null || offers === void 0 ? void 0 : offers.ownOffer,
            deviation: deviation
        }));
    }
    const showOfferBanner = offers && (((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.status) === 'onsale' || ((_deviation_adoptable2 = deviation.adoptable) === null || _deviation_adoptable2 === void 0 ? void 0 : _deviation_adoptable2.status) === 'pending');
    if (showOfferBanner) {
        return /*#__PURE__*/ React.createElement(OfferBanner, _object_spread_props(_object_spread({}, offers), {
            className: className,
            ownOffer: offers === null || offers === void 0 ? void 0 : offers.ownOffer,
            deviation: deviation,
            onEnd: onAdoptableSaleEnd
        }));
    }
    // dont show Monetization Strip on mobile
    if (isMobile) {
        return null;
    }
    if (!promo || ![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable',
        'core',
        'generic'
    ].includes(promo) || !deviation.author) {
        return null;
    }
    let link = '';
    let biData;
    const commonBiData = {
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.ART_STAGE_PROMOTION,
        section_typeid: deviation.typeId
    };
    if (promo === 'tier') {
        biData = BiData(_object_spread({
            evid: 547,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
    } else if (promo === 'core') {
        link = Url.coreMembershipLink();
        biData = BiData(_object_spread({
            evid: 375
        }, commonBiData));
    } else {
        link = Url.userLink(deviation.author.username, USER_PROFILE_SECTION_PATHS.SHOP);
    }
    const tPrefix = 'deviationview.artstage.monetizationStrip';
    let keyPrefix;
    if (promo === 'tier') {
        keyPrefix = `${tPrefix}.var.tier`;
    } else if (promo === 'core') {
        keyPrefix = `${tPrefix}.var.core`;
    } else {
        keyPrefix = `${tPrefix}.var.generic`;
    }
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        size: "small",
        variant: promo === 'core' ? 'upsell' : 'subscription',
        icon: promo !== 'core' && /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: promo !== 'tier' ? 'generic' : promo,
            size: 16
        }),
        messageAfterIcon: t(`${keyPrefix}.body`),
        ctaLabel: t(`${keyPrefix}.CTA`),
        ctaHref: link,
        ctaBiData: biData
    });
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
